import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";
import { getPricingType } from "sr/utils/api/masterData/getPricingType";
import { FormattedMessage } from "react-intl";

type Props = {
  data: { pricing_type?: string };
  HandleDataProps: (payload: { pricing_type: string }) => void;
};

const BidPricingTypeChange = forwardRef(({ data, HandleDataProps }: Props, ref) => {
  const [pricing, setPricing] = useState("");
  const [errorId, setErrorId] = useState<string>("");
  const validationErrorHandle = useValidationErrorHandle();
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    setPricing(data?.pricing_type || "");
  }, [data?.pricing_type]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getPricingType();
        if (res?.success && Array.isArray(res.data)) {
          const mapped = res.data.map((item: any) => ({
            value: item.value,
            label: item.label,
          }));
          setOptions(mapped);
        }
      } catch {}
    };
    load();
  }, []);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!pricing) { setErrorId('INPUT.VALIDATION.BID.PRICING_TYPE'); return false; }
      setErrorId('');
      return true;
    },
    submitForm: () => {
      const newData = { pricing_type: pricing };
      HandleDataProps(newData);
      return newData;
    },
  }));

  return (
    <div>
      <p className="pt-4 text-base">Pricing Type</p>
      <select
        className="w-full border rounded-lg p-2 mt-2"
        value={pricing}
        onChange={(e) => setPricing(e.target.value)}
      >
        {(options.length
          ? options
          : [
              { value: "fixed_price", label: "CORPORATE.RECRUITMENT.JOB.PRICINGTYPE.FIXED_PRICE" },
              { value: "hourly_rate", label: "CORPORATE.RECRUITMENT.JOB.PRICINGTYPE.HOURLY_RATE" },
            ]
        ).map((opt) => (
          <option key={opt.value} value={opt.value}>
            <FormattedMessage id={opt.label} defaultMessage={opt.label} />
          </option>
        ))}
      </select>
      {errorId && <div className="text-red-500 text-sm mt-2">{validationErrorHandle(errorId)}</div>}
    </div>
  );
});

export default BidPricingTypeChange;
